import strFunc from "@/lib/lyg/string";

function SumTableArea(props: any) {
  let myProps = {
    infoArr:[],
    ...props
  };
  let infoArr = myProps.infoArr;
  let supply_money=0;
  let discount_money=0;
  let supply_money_sum=0;
  let added_supply_money_sum=0;
  for(let i=0;i<infoArr.length;i++){
    let info=infoArr[i];
    if(info.supply_data&&info.supply_data.a_money_sum){
      supply_money+=parseInt(strFunc.uncomma(info.supply_data.a_money_sum));
      discount_money+=parseInt(strFunc.uncomma(info.a_discount_money));
    }
    added_supply_money_sum+=parseInt(strFunc.uncomma(info.added_supply_money_sum));
  }
  supply_money_sum=supply_money-discount_money;

  return (
    <div className="text-center mt-1">
      <div className="list-table-div mt-1" >
        <table style={{ width: "auto", margin: "0 auto" }}>
          <tbody>
            <tr>
              <th>클래스청구</th>
              <td>
                <div style={{ color: "green", fontWeight: "bold", minWidth: 100 }}>{strFunc.comma(supply_money_sum)}</div>
              </td>
              <th>청구된금액</th>
              <td>
              <div style={{ color: "green", fontWeight: "bold", minWidth: 100 }}>{strFunc.comma(added_supply_money_sum)}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default SumTableArea;